import { withCN } from "@discovery/jsx-utils";
import { Typography } from "@discovery/theming";
import * as styles from "./styles.css";
import * as M from "@discovery/prelude/lib/data/maybe";
import { H6 } from "@discovery/theming/lib/typography";
import { cn } from "@discovery/classnames";
export const Heading = Typography.styled(withCN(styles.heading)(Typography.H3));
export const SubHeading = Typography.styled(withCN(styles.subheading)(Typography.Paragraph));
export const Details = Typography.styled(withCN(styles.details)(Typography.Span));
export const Label = ({ children, classNameM = M.empty(), }) => (React.createElement(H6, { className: cn(classNameM, styles.lblStyles) }, children));
export const Paragraph = Typography.styled(Typography.Paragraph);

